import React, { Component } from 'react';
import { addonCheckout } from './checkout';
import '../../../assets/css/dashboard.css';
import apiInstance from '../../apiInstance';
import withRouter from '../../../utility/withRouter';

class Addons extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            websites: [],
            currentWebsite: {},
            skeletonLoading: true,
            error: "",
            msg: ""
        };
        this.popupRef = React.createRef();
    }

    async componentDidMount() {
        await apiInstance.get('/dashboard/websites')
            .then( async (response) => {
                const websites = response.data.websites;
                const currentWebsite = websites[0];
                this.setState(() => {
                    return ({
                        websites: websites,
                        currentWebsite: currentWebsite
                    })
                })

                if (currentWebsite) {
                    // Get active addons for the current site
                    // await apiInstance
                    //     .get(`/dashboard/emails/${currentWebsite._id}`)
                    //     .then((response) => {
                    //         this.setState({ error: "", msg: "" });
                    //         const emails = response.data.emails;
                    //         this.setState(() => {
                    //             return {
                    //                 currentSiteEmails: emails,
                    //             };
                    //         });
                    //     })
                    //     .catch((error) => {
                    //         console.error("Error fetching data:", error);
                    //         this.setState({ error: error.response?.data?.message || "Failed to load emails" });
                    //     });
                }

            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
            this.setState({skeletonLoading: false});
    }
    
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    getAddon = async (siteId, addonName) => {
        try {
            await addonCheckout({
                siteId,
                addonName,
                userEmail: this.props.user?.email
            });
        } catch (err) {
            console.error('Checkout failed:', err.message);
            this.setState({ error: err.message || "Request failed. Please contact us." });
        }
    }

    handleCurrentSiteChange = async (e) => {
        const selectedSite = e.target.value;
        let siteIndex = 0;
        this.state.websites.map((website, index) =>
            website.siteName === selectedSite ? (siteIndex = index) : ""
        );
        const currentWebsite = this.state.websites[siteIndex];
        this.setState({ currentWebsite: currentWebsite });

        this.setState({skeletonLoading: true});

        if (currentWebsite) {
            // Get active addons for the current site
            // await apiInstance
            //     .get(`/dashboard/emails/${currentWebsite._id}`)
            //     .then((response) => {
            //         this.setState({ error: "", msg: "" });
            //         const emails = response.data.emails;
            //         this.setState(() => {
            //             return {
            //                 currentSiteEmails: emails,
            //             };
            //         });
            //     })
            //     .catch((error) => {
            //         console.error("Error fetching data:", error);
            //         this.setState({ error: error.response?.data?.message || "Failed to load emails" });
            //     });            
        }

        this.setState({skeletonLoading: false});

    };

    render() {

        const websites = Array.isArray(this.state.websites) ? this.state.websites : [];
        const skeletonLoading = this.state.skeletonLoading;

        const currSiteId = this.state.currentWebsite?._id;
        const currSiteCodeName = this.state.currentWebsite?.siteName;
        const currSiteName = this.state.currentWebsite?.name;
        const currSiteStatus = this.state.currentWebsite?.status;
        const currSiteSubscriptionStatus = this.state.currentWebsite?.subscription?.status || '-';

        const {error, msg} = this.state;
        
        return (
            <>
                {websites?.length > 0 &&
                    <div className="mjs-dash-top">
                        <div className="mjs-dash-top-site-dd">
                            <span>Active Website </span>
                            <select
                                className="mjs-select"
                                value={currSiteCodeName}
                                onChange={this.handleCurrentSiteChange}
                            >
                                {websites.map((website, index) => (
                                    <option
                                        key={website._id}
                                        value={website.siteName}
                                    >
                                        {website.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }

                {error && <div className='mjs-error'>{error}</div> }   
                {msg && <div className='mjs-message'>{msg}</div> }

                <div className="mjs-dash-section">
                    <h4>Enhance Your Website</h4>
                    <p className="mjs-m-0">Add powerful features to your website with these Addons</p>

                    {websites?.length > 0 ?
                    <>

                        <div className="mjs-dash-sec-card-container mjs-dash-flex-wrap">

                            <div className="mjs-dash-sec-card">
                                {
                                skeletonLoading !== false ? 
                                    <>
                                        <div className='mjs_pre_skeleton_text mjs-width-50'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-70'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-75'></div>

                                        <div className="mjs-dash-card-action-btns mjs-mt-30">
                                            <div className='mjs_pre_skeleton_btn mjs-width-40'></div>
                                        </div>
                                    </>
                                    :
                                    <div className='mjs-flex-display'>
                                        <h5><i class="fa-solid fa-envelope mjs_text_grey"></i> Email Account</h5>
                                        <p>
                                            You get one email account with the LaunchPad plan. Add an extra email to your website with this addon.
                                        </p>
                                        <div className='mjs-align-btm'>
                                            <p>Price: $9 / One Time</p>
                                            <div className='mjs_text_grey mjs-btn'>Coming Soon</div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="mjs-dash-sec-card">
                                {
                                skeletonLoading !== false ? 
                                    <>
                                        <div className='mjs_pre_skeleton_text mjs-width-50'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-70'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-75'></div>

                                        <div className="mjs-dash-card-action-btns mjs-mt-30">
                                            <div className='mjs_pre_skeleton_btn mjs-width-40'></div>
                                        </div>
                                    </>
                                    :
                                    <div className='mjs-flex-display'>
                                        <h5><i class="fa-solid fa-magnifying-glass mjs_text_grey"></i> SEO Package</h5>
                                        <p>
                                            Optimize your website for Search Engine results and add Google Analytics to track website traffic.
                                        </p>
                                        <div className='mjs-align-btm'>
                                            <p>Price: $149 / month</p>
                                            <div className='mjs-btn mjs-btn-primary' onClick={() => this.getAddon(currSiteId, 'seo')}>Subscribe</div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="mjs-dash-sec-card">
                                {
                                skeletonLoading !== false ? 
                                    <>
                                        <div className='mjs_pre_skeleton_text mjs-width-50'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-70'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-75'></div>

                                        <div className="mjs-dash-card-action-btns mjs-mt-30">
                                            <div className='mjs_pre_skeleton_btn mjs-width-40'></div>
                                        </div>
                                    </>
                                    :
                                    <div className='mjs-flex-display'>
                                        <h5><i class="fa-solid fa-hard-drive mjs_text_grey"></i> Storage</h5>
                                        <p>
                                            You get 10 GB storage with the LaunchPad plan. Add another 10 GB space for your website.
                                        </p>
                                        <div className='mjs-align-btm'>
                                            <p>Price: $199 / One Time</p>
                                            <div className='mjs_text_grey mjs-btn'>Coming Soon</div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="mjs-dash-sec-card">
                                {
                                skeletonLoading !== false ? 
                                    <>
                                        <div className='mjs_pre_skeleton_text mjs-width-50'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-70'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-75'></div>

                                        <div className="mjs-dash-card-action-btns mjs-mt-30">
                                            <div className='mjs_pre_skeleton_btn mjs-width-40'></div>
                                        </div>
                                    </>
                                    :
                                    <div className='mjs-flex-display'>
                                        <h5><i class="fa-solid fa-location-dot mjs_text_grey"></i> Local Citations</h5>
                                        <p>
                                            We will add one section on home page and a dedicated page with content for local citations.
                                        </p>
                                        <div className='mjs-align-btm'>
                                            <p>Price: $199 / One Time</p>
                                            <div className='mjs_text_grey mjs-btn'>Coming Soon</div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="mjs-dash-sec-card">
                                {
                                skeletonLoading !== false ? 
                                    <>
                                        <div className='mjs_pre_skeleton_text mjs-width-50'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-70'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-75'></div>

                                        <div className="mjs-dash-card-action-btns mjs-mt-30">
                                            <div className='mjs_pre_skeleton_btn mjs-width-40'></div>
                                        </div>
                                    </>
                                    :
                                    <div className='mjs-flex-display'>
                                        <h5><i class="fa-solid fa-user-group mjs_text_grey"></i> Team Members</h5>
                                        <p>
                                            Add and display team members on your website. Manage them from the site dashboard.
                                        </p>
                                        <div className='mjs-align-btm'>
                                            <p>Price: $199 / One Time</p>
                                            <div className='mjs_text_grey mjs-btn'>Coming Soon</div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="mjs-dash-sec-card">
                                {
                                skeletonLoading !== false ? 
                                    <>
                                        <div className='mjs_pre_skeleton_text mjs-width-50'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-70'></div>
                                        <div className='mjs_pre_skeleton_text mjs-width-75'></div>

                                        <div className="mjs-dash-card-action-btns mjs-mt-30">
                                            <div className='mjs_pre_skeleton_btn mjs-width-40'></div>
                                        </div>
                                    </>
                                    :
                                    <div className='mjs-flex-display'>
                                        <h5><i class="fa-solid fa-code mjs_text_grey"></i> Custom Development</h5>
                                        <p>
                                            Add an extra section or custom feature to your website by our professional team of developers.
                                        </p>
                                        <div className='mjs-align-btm'>
                                            <p>Price: Quotation Based</p>
                                            <div className="mjs-btn mjs-btn-primary" onClick={() => this.props.navigate("/support")}>Send Requirements</div>
                                        </div>
                                    </div>
                                }
                            </div>
                            

                        </div>
                    </>
                    :
                    <>
                        {skeletonLoading !== false ? 
                            <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                        :
                            <p className='mjs_text_error'>You don't have any website yet!.</p>
                        }
                    </>
                    }
                </div>
                
            </>
        );
    }

}

export default (withRouter(Addons));
